import { Controller } from "@hotwired/stimulus"

// Extended bulk actions controller specifically for media management
// Inherits from and extends the base bulk actions functionality
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bulkActions", "selectedCount"]
  static values = {
    deleteUrl: String
  }

  connect() {
    this.updateBulkActionsVisibility()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateBulkActionsVisibility()
  }

  toggle() {
    this.updateBulkActionsVisibility()
    this.updateSelectAllState()
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return

    const allChecked = this.checkboxTargets.length > 0 &&
                       this.checkboxTargets.every(cb => cb.checked)
    const someChecked = this.checkboxTargets.some(cb => cb.checked)

    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = someChecked && !allChecked
  }

  updateBulkActionsVisibility() {
    const selectedCount = this.getSelectedIds().length

    if (this.hasBulkActionsTarget) {
      if (selectedCount > 0) {
        this.bulkActionsTarget.classList.remove("hidden")
      } else {
        this.bulkActionsTarget.classList.add("hidden")
      }
    }

    // Update all selected count targets (modal and bulk bar)
    this.selectedCountTargets.forEach(target => {
      target.textContent = selectedCount
    })
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  showDeleteModal() {
    const selectedCount = this.getSelectedIds().length

    if (selectedCount === 0) {
      alert("No files selected")
      return
    }

    // Update count in modal
    this.selectedCountTargets.forEach(target => {
      target.textContent = selectedCount
    })

    // Find the modal element by ID and show it
    const modalElement = document.getElementById("bulk-delete-modal")
    if (modalElement) {
      const dialog = modalElement.querySelector('[data-modal-target="dialog"]')
      if (dialog && dialog.showModal) {
        dialog.showModal()
      } else {
        // Fallback for older modal implementation
        modalElement.dispatchEvent(new CustomEvent("modal:open", { bubbles: true }))
      }
    }
  }

  hideDeleteModal() {
    const modalElement = document.getElementById("bulk-delete-modal")
    if (modalElement) {
      const dialog = modalElement.querySelector('[data-modal-target="dialog"]')
      if (dialog && dialog.close) {
        dialog.close()
      } else {
        // Fallback for older modal implementation
        modalElement.dispatchEvent(new CustomEvent("modal:close", { bubbles: true }))
      }
    }
  }

  confirmDelete(event) {
    event.preventDefault()
    const selectedIds = this.getSelectedIds()

    if (selectedIds.length === 0) {
      alert("No files selected")
      return
    }

    // Show loading state on button
    const button = event.currentTarget
    const originalText = button.textContent
    button.disabled = true
    button.textContent = "Deleting..."

    this.submitBulkAction(this.deleteUrlValue, selectedIds)
  }

  submitBulkAction(url, blobIds) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = url

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement("input")
      csrfInput.type = "hidden"
      csrfInput.name = "authenticity_token"
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    // Add blob IDs
    blobIds.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "blob_ids[]"
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}